<template>
  <div class="container mx-auto px-4 h-full">
    <!-- Password Recovery Modal -->
    <PasswordRecoveryModal
      v-if="showRecoveryModal"
      @close="showRecoveryModal = false"
      @success="showRecoveryModal = false"
    />
    <div
      style='z-index: 51;'
      v-if="alertOpen" 
      :class="[isError ? 'bg-red-500' : 'bg-emerald-500' ]"
      class="text-white px-6 py-4 border-0 rounded mb-4  absolute top-0 right-0">
      <span class="inline-block align-middle mr-8">
        <b class="">{{ msg }}</b>
      </span>
      <button
        class="absolute bg-transparent text-2xl font-semibold leading-none right-0 top-0 mt-4 mr-6 outline-none focus:outline-none" 
        v-on:click="closeAlert()"
        >
        <span>×</span>
      </button>
    </div>
    <div class="flex content-center items-center justify-center h-full">
      <div class="w-full lg:w-4/12 px-4">
        <div
          class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-200 border-0"
        >
          <div class="rounded-t mb-0 px-6 py-6">
          </div>
          <div class="flex-auto px-4 lg:px-10 py-10 pt-0">
            <div class="text-blueGray-400 text-center mb-3 font-bold">
              <big style='font-size: 18px;'>
                <b>FPV</b> <br>
                Платформа Онлайн-Курсов
              </big>
            </div>
            <form 
              :onsubmit="login"
            >
              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                  htmlFor="grid-password"
                >
                  Логин
                </label>
                <input
                  type="email"
                  v-model="input.login"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="Введите Логин"
                />
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                  htmlFor="grid-password"
                >
                  Пароль
                </label>
                <div class="relative">
                  <input
                    :type="showPassword ? 'text' : 'password'"
                    v-model="input.password"
                    class="border-0 px-3 py-3 pr-10 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    placeholder="Введите пароль"
                  />
                  <PasswordVisibilityToggle
                    :visible="showPassword"
                    @toggle="showPassword = !showPassword"
                  />
                </div>
              </div>

              <div class="text-center mt-6">
                <button
                  v-on:click='login'
                  class="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150"
                  type="button"
                >
                  Войти
                </button>
              </div>
            </form>
            <div class="text-center mt-4">
              <a href="#" @click.prevent="showRecoveryModal = true" class="text-sm text-blueGray-500 hover:text-blueGray-700 underline">
                Забыли пароль?
              </a>
            </div>
            <p class="text-xs text-blueGray-400 mt-4 text-center">
              Если вы забыли пароль, <router-link to="/client/feedback?from=/auth/login" class="underline text-blue-600">обратитесь к модератору</router-link> или контактному лицу платформы для восстановления доступа к аккаунту
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import axios from "axios";
import { API_AUTH, HEADERS } from '@/const/uri';
import { mapMutations } from 'vuex'
import PasswordRecoveryModal from "@/components/Auth/PasswordRecoveryModal.vue";
import PasswordVisibilityToggle from "@/components/Forms/PasswordVisibilityToggle.vue";

export default {
  components: {
    PasswordRecoveryModal,
    PasswordVisibilityToggle,
  },
  methods: {
    closeAlert () {
      this.alertOpen = false;
    }, 
    ...mapMutations(['createUser']),
    openSmModal(msg, isError=false) {
      this.isError = isError; 
      this.alertOpen = true; 
      this.msg = msg; 
      setTimeout(() => {
        this.alertOpen = false; 
      }, 1500);
    },

    async login() { 
      const self = this
      if(this.input.login === '' || this.input.password === '') {
        this.openSmModal('Пустые поля для ввода', true); 
        return false; 
      }
      const data = new FormData();
      data.append('login', this.input.login);
      data.append('password', this.input.password);
      await axios({
        method: "POST", 
        url: API_AUTH.login,
        data: data, 
        headers: HEADERS,
      }).then(function(e) {
        const data = e.data;
        if (data.code == 1) {
          self.openSmModal(e.message, true);
        } else {
          const token = data.data.token;
          self.createUser(data.data.user);
          localStorage.setItem("user_token", token);
          localStorage.setItem("user_token_expired", data.data.token_expired);
          // const routeName = data.data.user.role.key === 4 ? 'ExperProfieletList' : 'ClientCourseSatus';
          // this.$router.push({
          //   name: routeName,
          // });
          self.$router.push({
            name: 'ClientProfile',
          });
        }
      }).catch(function(e) {
        const data = (e.response && e.response.data) || {};
        const raw = data.error || data.errors || '';
        const text = typeof raw === 'string' ? raw : JSON.stringify(raw);
        if (text.includes('locked') || text.toLowerCase().includes('заблокирован')) {
          self.openSmModal('Аккаунт заблокирован. Слишком много неудачных попыток входа. Обратитесь к модератору, чтобы получить доступ к платформе.', true);
          return;
        }
        if (typeof raw === 'string' && raw) {
          self.openSmModal(raw, true);
          return;
        }
        if (raw && typeof raw === 'object') {
          const msg = Object.values(raw).map(v => Array.isArray(v) ? v.join(' ') : String(v)).join('; ');
          self.openSmModal(msg || 'Ошибка входа', true);
          return;
        }
        self.openSmModal('Ошибка входа', true);
      }); 

    }

  }, 
  data() {
    return {
      isError: false,
      alertOpen: false,
      isLogged: true,
      showRecoveryModal: false,
      showPassword: false,
      input: {
          msg: "",
          login: "",
          password: ""
      }
    };
  },
};
</script>
